export default __webpack_public_path__ + "static/media/nuvem.8ce5aa0b.svg";